import { Component, OnInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
import { CoreData } from './tools/core-data/core-data';

@Component({
    template: `
    <div class="pre d-flex justify-content-center  flex-column p-3" >
        <p class="text-center" style="font-size: 18px;"> {{ErrorMessage}} </p>
        <div class="d-flex justify-content-center">
            <!-- <img *ngIf="ErrorType !== ENavigationErrorType.IE" src="assets/icons/harnold.jpg">
            <img *ngIf="ErrorType === ENavigationErrorType.IE" src="assets/icons/TWBG.jpg"> -->
        </div>
        <div class="d-flex justify-content-center">
            <div *ngIf="ErrorType === ENavigationErrorType.IE">
                <a href="https://www.google.fr/chrome">Chrome</a><br/>
                <a href="https://www.mozilla.org/fr/firefox/new">FireFox</a>
            </div>
        </div>
    </div>
    `
})
export class ErrorComponent implements OnInit, AfterContentInit {

    ErrorMessage!: string;
    ErrorType!: ENavigationErrorType;
    ENavigationErrorType = ENavigationErrorType;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private coreData: CoreData) { }

    ngOnInit() {
    }

    ngAfterContentInit() {
        this.ErrorType = Number(this.route.snapshot.params.type) as ENavigationErrorType;
        switch (this.ErrorType) {
            case ENavigationErrorType.IE:
                this.ErrorMessage =
                    `Internet Explorer n'est plus maintenu par Microsoft et n'est plus accepté par les différentes politiques informatiques d'EUROFINS.
                    Merci d'utiliser un navigateur valide afin d'accéder aux differents outils informatiques :`;
                break;
            case ENavigationErrorType.UnAuthenticated:
                if (!this.coreData.Token) {
                    this.router.navigate([ENavigationRoute.Login]);
                } else if (this.coreData.WithOauth2) {
                    window.open(`${environment.launcherUrl}?appCode=${environment.appCode}`, '_self');
                }
                break;
            case ENavigationErrorType.UnAuthorized:
                this.ErrorMessage = `Désolé vous n'avez pas les permissions nécéssaires pour accéder à cette page`;
                break;
            default:
                this.ErrorMessage = `Désolé nous n'avons pas pu trouver la page que vous avez demandé.`;
        }
    }
}
